import axios from 'axios'

function issueAccessId(statsId, statsName, data) {
  const jsonRawString = JSON.stringify(data);
  return new Promise(resolve => {
    return axios.post(`${process.env.VUE_APP_SERVER}/api/mystats/url/issue`, {
      statsId: statsId,
      statsName: statsName,
      url: window.location.href,
      data: jsonRawString
    }).then(result => {
      resolve(result.data.accessUrl);
    });
  });
}

function getStatsParameters(accessId) {
  return new Promise(resolve => {
    return axios.get(`${process.env.VUE_APP_SERVER}/api/mystats/parameter?accessId=${accessId}`).then(result => {
      resolve(JSON.parse(result.data.data));
    });
  });
}

export {issueAccessId, getStatsParameters}
